import React from "react";
import useTranslator from "../../hooks/useTranslator";

const PolicyMetricSection = ({ title, badge, rows, icon }) => {
  const { _t } = useTranslator();

  const decodeHtml = (text) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  const translateValue = (value) => {
    const stringValue = String(value ?? "");

    let translated;

    if (stringValue.includes("&")) {
      translated = stringValue
        .split("&")
        .map((item) => _t(item.trim()))
        .join(" & ");
    } else {
      translated = _t(stringValue);
    }

    return decodeHtml(translated);
  };

  return (
    <div className="linked-report__metric-block">
      <div className="linked-report__metric-header">
        {icon && <div className="linked-report__policy-icon">{icon}</div>}
        <h3>{title}</h3>
        <span
          className={`linked-report__status-pill linked-report__status-pill--${badge.variant}`}
        >
          {badge.label}
        </span>
      </div>
      {rows.map((row, index) => (
        <div className="linked-report__row" key={index}>
          <span>{row.label}</span>
          <span className={row.muted ? "linked-report__muted" : ""}>
            {translateValue(row.value)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PolicyMetricSection;
